import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AddProfile from './addProfile';
import ViewUser from './viewUser';
import Permissions from './permissions';

const Profile = ({ details }) => {
  let title = details?.title;
  let description = details?.description;
  const location = useLocation();

  const tableData = [
    {
      id: 1,
      profileName: 'Administrator',
      text: 'This profile will have all the permissions except admi',
      createdBy: 'John Doe',
      modifiedBy: 'John Doe',
    },
    {
      id: 2,
      profileName: 'Administrator',
      text: 'This profile will have all the permissions except admi',
      createdBy: 'John Doe',
      modifiedBy: 'John Doe',
    },
    {
      id: 3,
      profileName: 'Administrator',
      text: 'This profile will have all the permissions except admi',
      createdBy: 'John Doe',
      modifiedBy: 'John Doe',
    },
  ];

  const [expandedRows, setExpandedRows] = useState({});

  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getDisplayText = (text, isExpanded) => {
    const maxLength = 50; // Truncate to 50 characters
    if (isExpanded || text.length <= maxLength) return text;
    return `${text.substring(0, maxLength)}...`;
  };

  const dropdownRef = useRef(null);

  const toggleDropdown = (id) => {
    setActiveDropdown((prevId) => (prevId === id ? null : id));
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [showAddProfilePopup, setShowAddProfilePopup] = useState(false);
  const openPopup1 = () => {
    setShowAddProfilePopup(true);
  };

  const closeAddProfilePopup = () => {
    setShowAddProfilePopup(false);
  };

  const [ShowViewUserPopup, setShowViewUserPopup] = useState(false);

  const openPopup2 = () => {
    setShowViewUserPopup(true);
  };

  const closeViewUserPopup = () => {
    setShowViewUserPopup(false);
  };

  const [ShowPermissionPopup, setShowPermissionPopup] = useState(false);

  const openPopup3 = () => {
    setShowPermissionPopup(true);
  };

  const closePermissionPopup = () => {
    setShowPermissionPopup(false);
  };

  return (
    <>
      <div className="ViewLeadPageOuter">
        <div className="viewFormContainer">
          <div className="rightBlock">
            <div className="whiteBlock">
              <div className="rightheader">
                <div className="flexDivhd">
                  <h2 className="pb-0">Profile</h2>
                  <button className="btn btn-primary" onClick={openPopup1}>
                    {' '}
                    New Profile
                  </button>
                </div>
              </div>
              <div className="rightContent">
                <div className="tblheader">
                  <div className="searchBoxTable">
                    <input
                      className="form-control"
                      id="filter-text-box"
                      type="Text"
                      placeholder="Search..."
                    />
                  </div>
                </div>
                <div className="settingTable">
                  <table className="table  table-bordered table-hover" id="example">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Profile Name</th>
                        <th>Profile Description</th>
                        <th>Created By</th>
                        <th>Modified By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row) => (
                        <tr key={row.id}>
                          <td className="vAlign">
                            <div className="dropdown">
                              <button className="menuBtn" onClick={() => toggleDropdown(row.id)}>
                                <img src="../assets/images/dots.svg" alt="" width="18px" />
                              </button>
                              {activeDropdown === row.id && (
                                <ul className="dropMenu" ref={dropdownRef}>
                                  <li className="dropItem" to="#">
                                    {' '}
                                    <Link to="#" onClick={openPopup1}>
                                      Clone
                                    </Link>
                                  </li>
                                  <li className="dropItem" to="#">
                                    <Link to="#" onClick={openPopup2}>
                                      View Users
                                    </Link>
                                  </li>
                                </ul>
                              )}
                            </div>
                          </td>
                          <td>
                            <Link to="#" onClick={openPopup3}>
                              {row.profileName}
                            </Link>
                          </td>
                          <td>
                            {getDisplayText(row.text, expandedRows[row.id])}
                            {!expandedRows[row.text] && row.text.length > 50 && (
                              <button onClick={() => toggleRow(row.id)} className="moreBtn">
                                {expandedRows[row.id] ? 'Less' : 'More'}
                              </button>
                            )}
                          </td>
                          <td>{row.createdBy}</td>
                          <td>{row.modifiedBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {showAddProfilePopup && <AddProfile handleClose={closeAddProfilePopup} />}

              {ShowViewUserPopup && <ViewUser handleClose={closeViewUserPopup} />}

              {ShowPermissionPopup && <Permissions handleClose={closePermissionPopup} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
